import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { ArgoConnectionKindEnum } from '@redviking/argonaut-util/types/db-enums/argo/connection_kind';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const deactivatePickLightUiNodeSpec: NodeSpec<NodeCfg<'deactivatePickLight'>> = {
    nodeCategory: 'connection',
    nodeSubCategory: 'Pick Light',
    requiredSockets: [ 'channelNumber', 'pickLightId', 'deactivate' ],
    kindLabel: 'Deactivate Pick Light',
    controls: nodeCfg => ({
        connectionId: defineControlOpts({
            cfg: {
                kind: 'connectionSelect',
                label: 'Connection',
                allowedConnectionKinds: [ ArgoConnectionKindEnum.Ptl110PickLight ],
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.connectionId,
        }),
    }),
    cfg: () => ({ id: getUID(), kind: 'deactivatePickLight', controlValues: { connectionId: '' }, width: 220 }),
    inputs: nodeCfg => ({
        deactivate: {
            socket: 'event',
            label: 'Deactivate',
        },
        pickLightId: {
            socket: 'number',
            label: 'Light Id',
            controlOpts: defineControlOpts({
                value: nodeCfg.socketDefaults?.inputs?.pickLightId,
                cfg: {
                    min: 1,
                    max: 256,
                    kind: 'number',
                },
                on: { 'update:value': defaultControlUpdateValueHandler },
            }),
        },
        channelNumber: {
            socket: 'number',
            label: 'Channel Number',
            controlOpts: defineControlOpts({
                value: nodeCfg.socketDefaults?.inputs?.channelNumber,
                cfg: {
                    min: 0,
                    max: 4,
                    kind: 'number',
                },
                on: { 'update:value': defaultControlUpdateValueHandler },
            }),
        },
    }),
    outputs: () => ({}),
    validator: node => node.controlValues.connectionId
        ? true
        : { connectionId: 'Connection id is required' },
};
